import React, {useState, useReducer, useEffect,}from 'react';
import ReactDOM from "react-dom";
import { forwardRef } from "react";
import * as currency from "@shopify/theme-currency";
import { CustomizerProduct, ProductCustomizerState, CustomizerLabelData } from "../types/ProductCustomizer";
import { CartFormData, CartLineItemProperties } from '../types/Cart';
import { ProductCustomizerStep } from './ProductCustomizerStep';
import { ProductCustomizerImages } from './ProductCustomizerImages';
import { PaymentOptions} from './PaymentOptions';
import { SocialShare } from './SocialShare';
import { productOptionToString } from '../utils/productOptionToString';
import { Logo } from './Logo';
import { ButtonPrev } from './ButtonPrev';
import { ButtonPrevBack } from './ButtonPrevBack';
import { ButtonNext } from './ButtonNext';
import { CameraIntro } from './CameraIntro';
import formatVariantTitle from '../utils/formatVariantTitle';
import { Measure } from './Measure';
import { WizardState } from '../types/WigWizard'
import { User } from '../types/User'
import { WigWizardReducer } from '../reducers/WigWizardReducer'


export const ProductCustomizerModal = forwardRef(({ state, handleFieldChange, handleOptionChange, handleProductChange, product, getVariantPriceDifference, getProductPriceDifference, handleUpdatedOption, dispatch }: { state: ProductCustomizerState, handleFieldChange: Function, handleOptionChange: Function, handleProductChange: Function, product: CustomizerProduct, getVariantPriceDifference: Function, getProductPriceDifference: Function, handleUpdatedOption: Function, dispatch: Function }, ref) => {

  /*
    Add to cart
  */

  
  function getLineItemPropertiesObj() {
    let obj: CartLineItemProperties = {};
    state.selectedOptions?.forEach((option: number | null, step: number) => {
      const currentStep = state.steps[step];

      if (currentStep.type === "line_item" && option != null) {
        const { key, option_value } = productOptionToString(state.steps, step, option);
        obj[key] = option_value;
      }
    });
    

    // Add Camera Wizard properties
    if (state2.capSize) obj["_Cap_Size"] = state2.capSize;
    if (state2.laceTintDescription) obj["_Lace_Tint_Description"] = state2.laceTintDescription;
    if (state2.laceTint) obj["_Lace_Tint_Hex"] = state2.laceTint;
    if (state2.s3BucketFolder) obj["_s3_bucket_folder"] = state2.s3BucketFolder;

    if (state.variant.featured_image) {
      obj["_sku_image"] = state.variant.featured_image.src;
    } else {
      obj["_sku_image"] = product.featured_image;
    }

    const quantityJSON = JSON.parse(document.querySelector("[data-variant-quantity]")?.innerHTML || '{}')
    obj["_In_Stock"] = (quantityJSON[state.variant.id] > 0).toString();
    obj["_orderNo"]=state.orderNo
    return obj;
  }

  function addToCart(event: any): void {

    const item={
      id: state.variant.id,
      quantity: 1,
      properties: getLineItemPropertiesObj()
    }

    const formData: CartFormData = {
      items: [
        {
          id: state.variant.id,
          quantity: 1,
          properties: getLineItemPropertiesObj()
        },
      ],
      note: state.cartNote ? state.cartNote : null,
    }
   
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((res) => {
       window.location.href = "/cart";
    }).catch((error) => {
     
      console.log("Error")
    });
  }


  function isIntroStep() {
    if (state.steps.length > 0) {
      if (state.steps[state.activeStep].id === "intro") return true;
      return false;
    }
  }

  // Check local storage for Camera Wizard state
  // let localStoreWizardState: WizardState;
  // if (localStorage.getItem("wizardMeasurements") !== null) {
  //   localStoreWizardState = JSON.parse(localStorage.getItem("wizardMeasurements"));
  // }

  //check cameroIntro
  // JSON.parse(localStorage.getItem('wizardState'))
  const [cameraVisible, setCameraVisible] = useState(false)
  const selectors = {
    userData: '[data-customer-data]',
    frontImage: '[data-variant-id] img',
    startMeasurements: '[data-start-measurements]',
  }
  const user: User = JSON.parse(document.querySelector(selectors.userData).innerHTML)
  const initialState: WizardState = {
    steps: [{}, {}, {}, {}],
    active: 0,
    capSize: user.cap_size ,
    laceTint: user.lace_tint,
    laceTintDescription: user.lace_tint_description,
    s3BucketFolder: user.s3_bucket_folder,
    frontImage: document.querySelector<HTMLImageElement>(selectors.frontImage)?.src,
    captchaCompleted: false
  }

  const [state2, dispatch2] = useReducer(WigWizardReducer, initialState);




   return (
    state.cameraIntro?
   (<div id="customizer" aria-hidden={!state.activeModal} className={`overflow-x-hidden overflow-y-auto fixed inset-0 z-20 text-black bg-white ${state.activeModal ? "block" : "hidden"}`
   
   
   
   } >
    <CameraIntro close={() => dispatch({
          type: "cameraIntro",
          value: false
        })} next={() => { dispatch({
          type: "cameraIntro",
          value: false
        }); setTimeout(() => { setCameraVisible(true) }, 10) }} dispatch={dispatch} state={state}/>
        </div>):
    cameraVisible ?
     (<div aria-hidden={!cameraVisible}  className="fixed top-0 left-0 bg-white w-screen h-screen z-20">
          <Measure setCameraVisible={setCameraVisible} state={state2} dispatch={dispatch2} user={user} stateProductCustomizer={state} dispatchProductCustomizer={dispatch}/>
      </div>):

   (ReactDOM.createPortal(
    <div
      ref={ref}
      id="customizer"
      aria-hidden={!state.activeModal}
      className={`overflow-x-hidden overflow-y-auto fixed inset-0 z-20 text-black bg-white ${state.activeModal ? "block" : "hidden"}`}
    >

      {product &&
        <div className="min-h-screen">
          <div className={`relative min-h-screen md:flex ${isIntroStep() && 'flex flex-col md:flex-row justify-between'}`}>

            {!isIntroStep() && state.steps.length > 0 && <div className="flex w-full md:hidden z-20">
              <label htmlFor="progress-mobile" className="sr-only">Step {state.activeStep} out of {state.steps.length} steps</label>
              <progress
                id="progress-mobile"
                max="100"
                value={(state.activeStep / state.steps.length) * 100}
                className="h-[3px] w-full"
              >
              </progress>
            </div>}

            <div className={`grid md:hidden grid-cols-[4rem_1fr_4rem] items-center px-[1rem] lg:px-[3rem] pt-[0.5rem] pb-[0.75rem] z-10 relative ${isIntroStep() ? 'theme-dark' : 'theme-light'}`}>
              <ButtonPrev activeStep={state.activeStep} dispatch={dispatch} className="md:hidden" />
              <div className="col-start-2 text-center">
                {isIntroStep()
                ? <Logo />
                :
                  <>
                    <h1 className="new-h5 text-[1rem] font-medium normal-case">{product.title}</h1>
                    <p className="text-[0.675rem] uppercase font-medium my-[0.25rem]">{product.subtitle ? product.subtitle : formatVariantTitle(state.variant)}</p>
                    {/* {(state.variant.compare_at_price&&state.variant.price!==state.variant.compare_at_price)?<><p className="text-xs font-bold">Subtotal</p>
                    <p className="text-xs font-bold">{currency.formatMoney(state.variant?.price, "${{amount_no_decimals}}")}</p>
                    <p className="text-xs font-bold">{currency.formatMoney(state.variant?.compare_at_price, "${{amount_no_decimals}}")}</p></>: */}
                    <p className="text-xs font-medium">Subtotal: {currency.formatMoney(state.variant?.price, "${{amount_no_decimals}}")}</p>
                    {/* } */}
                    
                     <PaymentOptions price={ state.variant?.price}/>
                     {/* <SocialShare/> */}
                  </>
                }
              </div>
              <button
                className="md:hidden flex justify-self-end items-center rounded-full h-[3rem] w-[3rem] justify-end cursor-pointer"
                onClick={() => handleFieldChange("activeModal", !state.activeModal)}
                title="Modal"
              >
                <span className="sr-only">Close modal</span>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.0008 12.3502L19.7758 6.5752L21.4255 8.22486L15.6505 13.9999L21.4255 19.7749L19.7758 21.4245L14.0008 15.6495L8.22584 21.4245L6.57617 19.7749L12.3512 13.9999L6.57617 8.22486L8.22584 6.5752L14.0008 12.3502Z" fill="currentColor"/>
                </svg>
              </button>
            </div>

            <div className={`bg-blush-100 md:w-full md:h-screen md:sticky top-0 ${isIntroStep() ? 'absolute md:top-0 w-full h-full md:static' : ''}`}>
              <ProductCustomizerImages state={state} product={product} dispatch={dispatch} />
            </div>

            <div className={`relative md:w-[30.5rem] md:shrink-0 ${isIntroStep() ? 'theme-dark' : 'theme-light'}`}>
              {!isIntroStep() && state.steps.length > 0 && <div className="hidden absolute md:flex w-full z-20 md:absolute md:top-0">
                <label htmlFor="progress-desktop" className="sr-only">Step {state.activeStep} out of {state.steps.length} steps</label>
                <progress
                  id="progress-desktop"
                  max="100"
                  value={(state.activeStep / state.steps.length) * 100}
                  className="h-[3px] w-full"
                >
                </progress>
              </div>}
              <div className={`flex h-full flex-col justify-between ${isIntroStep() ? '' : ''}`}>
                <div className={`flex justify-between flex-col md:block h-full w-full`}>
                  <div className={`hidden md:grid grid-cols-[4rem_1fr_4rem] items-center px-[1rem] md:px-[3rem] py-[1rem] z-10 ${isIntroStep() ? '' : 'md:sticky md:top-0 bg-white'}`}>
                    <ButtonPrev  activeStep={state.activeStep} dispatch={dispatch} />
                    <div className="col-start-2 text-center">
                      {isIntroStep()
                      ? <Logo />
                      :
                        <>
                          <h1 className="new-h5 text-[1.125rem] normal-case">{product.title}</h1>
                          <p className="md:text-xs uppercase font-medium my-[0.5rem]">{product.subtitle ? product.subtitle : formatVariantTitle(state.variant)}</p>
                    {/* {(state.variant.compare_at_price&&state.variant.price!==state.variant.compare_at_price)?<><p className="text-xs font-bold">Subtotal</p>
                    <p className="text-xs font-bold">{currency.formatMoney(state.variant?.price, "${{amount_no_decimals}}")}</p>
                    <p className="text-xs font-bold">{currency.formatMoney(state.variant?.compare_at_price, "${{amount_no_decimals}}")}</p></>: */}
                    <p className="text-xs font-medium">Subtotal: {currency.formatMoney(state.variant?.price, "${{amount_no_decimals}}")}</p>
                    {/* } */}
                    
                       <PaymentOptions price={ state.variant?.compare_at_price?state.variant?.compare_at_price:state.variant?.price}/>
                  
                       {/* <SocialShare/> */}
                        </>
                    }
                    </div>
                    <button
                      className="flex justify-self-end items-center rounded-full h-[3rem] w-[3rem] justify-end cursor-pointer"
                      onClick={() => handleFieldChange("activeModal", !state.activeModal)}
                      title="Modal"
                    >
                      <span className="sr-only">Close modal</span>
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0008 12.3502L19.7758 6.5752L21.4255 8.22486L15.6505 13.9999L21.4255 19.7749L19.7758 21.4245L14.0008 15.6495L8.22584 21.4245L6.57617 19.7749L12.3512 13.9999L6.57617 8.22486L8.22584 6.5752L14.0008 12.3502Z" fill="currentColor"/>
                      </svg>
                    </button>
                  </div>
                  <div className="px-[1rem] md:px-[3rem]">
                 
                    {state.steps.map((step, index) => {
                      return (
                        <ProductCustomizerStep state={state} stateCameraWizard={state2} product={product} step={step} index={index} getVariantPriceDifference={getVariantPriceDifference} getProductPriceDifference={getProductPriceDifference} handleProductChange={handleProductChange} handleOptionChange={handleOptionChange} handleUpdatedOption={handleUpdatedOption} handleFieldChange={handleFieldChange} dispatch={dispatch} />
                      )
                    })}
                  </div>
           
                </div>
                
               
                <div className={`sticky bottom-0 py-[1.25rem] pl-[3rem] ${isIntroStep() ? 'block bottom-0 md:bg-black' : 'bg-white'}`}>
                  <ButtonNext steps={state.steps} activeStep={state.activeStep} dispatch={dispatch} addToCart={addToCart} stateCameraWizard={state2} />

                {/* summary page hide the back button */}
              {state.steps[state.activeStep].id != "summary" ?  <div>
              <ButtonPrevBack steps={state.steps} activeStep={state.activeStep} dispatch={dispatch} className="" />
              </div>:<></>}
            
       
                  {state.steps[state.activeStep] && state.steps[state.activeStep].button_secondary &&
                    <button
                      onClick={() => dispatch({
                        type: "activeStep",
                        value: 0
                      })}
                      className="text-sm underline underline-offset-4 font-medium uppercase mt-[0.75rem]"
                    >
                      {state.steps[state.activeStep].button_secondary.label}
                    </button>

                  }
              
                {state.steps[state.activeStep] && state.steps[state.activeStep].button_skip&&
                <div>
                  <button onClick={() =>{

                        // hide use ai meansuremnt option if skip camera
                        if(state.steps[state.activeStep].button_skip){
                          document.getElementById('RadioButton-circumference-0').style.display="none"
                          document.getElementById('RadioButton-Lace_Tint-0').style.display="none"
                        }
                        dispatch({
                         type: "activeStep",
                         value: state.activeStep+3
                       })}} className="theme-light font-medium rounded uppercase text-xs w-11/12 px-[3rem] py-[1.125rem]"

                       style="margin-top:10px ; border:1px solid black">
                    
                        {state.steps[state.activeStep].button_skip.label}
                       </button>
                       
                    <p className="text-sm mt-[1.75rem] w-fullleading-6 ">You can take wig cap size photos after purchasing your wig if you would prefer. We'll send you an email with the necessary information after purchase.</p>
                    </div>
                  }

                </div>
                
              </div>
            </div>
          </div>
        </div>
      }
      </div>,
      document.body
  ))

   )
});
